import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }

  stop (event) {
    event.preventDefault()
    event.stopPropagation()
  }

  async toggle (event) {
    this.stop(event)

    const response = await fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.csrfToken,
        Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml'
      },
      credentials: 'same-origin'
    })

    if (!response.ok) return

    const contentType = response.headers.get('content-type') || ''
    const body = await response.text()

    if (contentType.includes('text/vnd.turbo-stream.html') && window.Turbo?.renderStreamMessage) {
      window.Turbo.renderStreamMessage(body)
    } else if (body.includes('<turbo-stream')) {
      window.Turbo?.renderStreamMessage(body)
    }
  }

  get csrfToken () {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
